export enum Extension {
  Excel = '.xlsx',
  CSV = '.csv',
}
